import * as React from "react";
import "./badgeChain.css";
import "../../style/fonts.css";
import badge_locked from "../../icons/badges/lock_1.png";
import translate from "../../translations/i18n";
import starIcon1x from "../../icons/atoms/star_icon_white/star_filled_small_turquese_centered.png";
import starIcon2x from "../../icons/atoms/star_icon_white/star_filled_small_turquese_centered@2x.png";
import starIcon3x from "../../icons/atoms/star_icon_white/star_filled_small_turquese_centered@3x.png";
// ../../icons/⁨atoms⁩/⁨star_icon_white⁩/⁨star_filled_small_turquese_centered.png
//These badges will be assigned if there is no exact badge in '/icons/badges/' folder
import badge_1 from "../../icons/badges/badge_supporting_1.png";
import badge_2 from "../../icons/badges/badge_supporting_2.png";
import badge_3 from "../../icons/badges/badge_supporting_3.png";

const MAX_STATE = 3;
const STATE_1_STAR = "500";
const STATE_2_STAR = "1.000";
const STATE_3_STAR = "2.000";

export interface Props {
  category: string;
  state: number;
}

class BadgeChain extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  stage1() {
    let badge1;
    if (this.props.state === 0) {
      return <img src={badge_locked} width="160px" height="142px" />;
    } else {
      try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        badge1 = require("../../icons/badges/badge_" +
          this.props.category.toLowerCase() +
          "_1.png");
      } catch (e) {
        badge1 = badge_1;
      }
      return <img src={badge1} width="160px" height="142px" />;
    }
  }

  handleOpacity1() {
    const op = {
      opacity: 0.3
    };
    if (this.props.state === 0) {
      return (
        <div className="STAR_CONT">
          <div className="STAGE_1_STARS" style={op}>
            <div className="TITLE_3_BADGE">{STATE_1_STAR}</div>
          </div>
          <div className="STAGE_1_BADGE_STAR" style={op}>
            <img
              src={starIcon1x}
              srcSet={`${starIcon1x} 1x, ${starIcon2x} 2x, ${starIcon3x} 3x`}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="STAR_CONT">
          <div className="STAGE_1_STARS">
            <div className="TITLE_3_BADGE">{STATE_1_STAR}</div>
          </div>
          <div className="STAGE_1_BADGE_STAR">
            <img
              src={starIcon1x}
              srcSet={`${starIcon1x} 1x, ${starIcon2x} 2x, ${starIcon3x} 3x`}
            />
          </div>
        </div>
      );
    }
  }

  stage2() {
    let badge2;
    if (this.props.state === 0 || this.props.state === 1) {
      return <img src={badge_locked} width="160px" height="142px" />;
    } else {
      try {
        badge2 = require("../../icons/badges/badge_" +
          this.props.category.toLowerCase() +
          "_2.png");
      } catch (e) {
        badge2 = badge_2;
      }
      return <img src={badge2} width="160px" height="142px" />;
    }
  }

  handleOpacity2() {
    const op = {
      opacity: 0.3
    };
    if (this.props.state === 0 || this.props.state === 1) {
      return (
        <div className="STAR_CONT">
          <div className="STAGE_2_STARS" style={op}>
            <div className="TITLE_3_BADGE">{STATE_2_STAR}</div>
          </div>
          <div className="STAGE_2_BADGE_STAR" style={op}>
            <img
              src={starIcon1x}
              srcSet={`${starIcon1x} 1x, ${starIcon2x} 2x, ${starIcon3x} 3x`}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="STAR_CONT">
          <div className="STAGE_2_STARS">
            <div className="TITLE_3_BADGE">{STATE_2_STAR}</div>
          </div>
          <div className="STAGE_2_BADGE_STAR">
            <img
              src={starIcon1x}
              srcSet={`${starIcon1x} 1x, ${starIcon2x} 2x, ${starIcon3x} 3x`}
            />
          </div>
        </div>
      );
    }
  }

  stage3() {
    let badge3;
    if (
      this.props.state === 0 ||
      this.props.state === 1 ||
      this.props.state === 2
    ) {
      return <img src={badge_locked} width="160px" height="142px" />;
    } else {
      try {
        badge3 = require("../../icons/badges/badge_" +
          this.props.category.toLowerCase() +
          "_3.png");
      } catch (e) {
        badge3 = badge_3;
      }
      return <img src={badge3} width="160px" height="142px" />;
    }
  }

  handleOpacity3() {
    const op = {
      opacity: 0.3
    };
    if (
      this.props.state === 0 ||
      this.props.state === 1 ||
      this.props.state === 2
    ) {
      return (
        <div className="STAR_CONT">
          <div className="STAGE_3_STARS" style={op}>
            <div className="TITLE_3_BADGE">{STATE_3_STAR}</div>
          </div>
          <div className="STAGE_3_BADGE_STAR" style={op}>
            <img
              src={starIcon1x}
              srcSet={`${starIcon1x} 1x, ${starIcon2x} 2x, ${starIcon3x} 3x`}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="STAR_CONT">
          <div className="STAGE_3_STARS">
            <div className="TITLE_3_BADGE">{STATE_3_STAR}</div>
          </div>
          <div className="STAGE_3_BADGE_STAR">
            <img
              src={starIcon1x}
              srcSet={`${starIcon1x} 1x, ${starIcon2x} 2x, ${starIcon3x} 3x`}
            />
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="BADGECHAIN_CONT_OUTER">
        <div className="BADGECHAIN_CONT">
          <div className="BADGECHAIN_TITLE">
            <div className="AWARD_TITLE">
              <div className="TITLE_3">{this.props.category} AWARDS</div>
            </div>
            <div className="PROGRESS_COUNTER">
              <div className="SMALL_TEXT1">
                {this.props.state} of {MAX_STATE} achieved
              </div>
            </div>
          </div>
          <div className="BADGECHAIN_CONTENT">
            <hr className="LINE_BADGE" />
            <div className="BADGE_1_CONT">
              <div className="STAGE_1_BADGE">{this.stage1()}</div>
              {this.handleOpacity1()}
            </div>
            <div className="BADGE_2_CONT">
              <div className="STAGE_2_BADGE">{this.stage2()}</div>
              {this.handleOpacity2()}
            </div>
            <div className="BADGE_3_CONT">
              <div className="STAGE_3_BADGE">{this.stage3()}</div>
              {this.handleOpacity3()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BadgeChain;



// WEBPACK FOOTER //
// ./src/components/badges/badgeChain.tsx